import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as UsersSvg } from './assets/users-filled.svg';

const UsersFilledIcon = React.forwardRef((args, ref) => <SvgIcon component={UsersSvg} ref={ref} {...args} />);

export default UsersFilledIcon;
